<div class="error-region">
  <div class="error-region-content">
    <div class="error-region-content-error">
      <div class="error-img">
        <app-icon [name]="'error-region'" [width]="'5.7vw'" [height]="'13.4vh'"></app-icon>
      </div>
      <div class="error-region-content-error-content">
        <h1>{{ 'region.title' | translate }}</h1>
        <p>{{ 'region.message' | translate }}</p>
      </div>
    </div>
  </div>
</div>
